import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Maintenance from "./components/Maintenance";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { ConfirmProvider } from "material-ui-confirm";
import TagManager from "react-gtm-module";
import { GA_TRACKINGID, GTM_ID } from "./API/Environment";
import { getBypassAccess, saveBypassAccess } from "./API/LocalStore";

const tagManagerArgs = { gtmId: GTM_ID };
TagManager.initialize(tagManagerArgs);

// App wrapper
const Root = () => {
    const [clientIp, setClientIp] = useState(null);

    // Load client IP
    useEffect(() => {
        fetch("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => setClientIp(data.ip));
    }, []);

    // Check secret in URL
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const accessParam = urlParams.get("access");
        const allowedSecret = process.env.REACT_APP_ALLOWED_SECRET;

        if (accessParam === allowedSecret) {
        saveBypassAccess();
        window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    const allowedIps = ["46.185.168.126"];
    const isAllowedIp = allowedIps.includes(clientIp);
    const isBypassToken = getBypassAccess();
    const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE === "true";

    const allowAccess = !isMaintenanceMode || isAllowedIp || isBypassToken;

    const AppToRender = allowAccess ? <App /> : <Maintenance />;

    if (isMaintenanceMode && clientIp === null) return null;

    return (
        <Provider store={store}>
        <ConfirmProvider>
            <BrowserRouter>{AppToRender}</BrowserRouter>
        </ConfirmProvider>
        </Provider>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>,
    document.getElementById("root")
);

reportWebVitals();